import React, { useEffect, useState } from "react";
import uploadImage from "../../../assets/images/icons/upload.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { doc, updateDoc, arrayRemove, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { uploadImage as uploadImageToService } from "../../../utils/imageUpload";

const SliderUploader = ({
  title,
  text,
  showText,
  SelectedData,
  data,
  enableReset,
  dataUpdate,
  profileEdit,
  accept = "",
  value = [],
}) => {
  const [selectedFiles, setSelectedFiles] = useState([...value]);
  const { t } = useTranslation();
const [loading, setloading] = useState(false);
  // Fetch existing images from Firestore on component mount
  function generateUniqueKey() {
    const timestamp = Date.now(); // Current timestamp
    const randomString = Math.random().toString(36).substring(2, 15); // Random string
    return `${timestamp}-${randomString}`;
}

  const handleFileChange = (event) => {
    const files = event.target.files;
    const updatedFiles = [...selectedFiles];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      updatedFiles.push({
        file: file,
        name: file.name,
        type: file.type,
        preview: URL.createObjectURL(file),
        downloadURL: null,
      });
    }

    setSelectedFiles(updatedFiles);
  };

  const handleDelete = async (index) => {
    const fileToDelete = selectedFiles[index];
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);

    setSelectedFiles(updatedFiles);
    // Delete file if it has been uploaded
    if (fileToDelete.file && fileToDelete.downloadURL) {
      // Remove download URL from Firestore
      const docRef = doc(db, "OurClinc", "images"); // Document path: "OurClinic/images"
      await updateDoc(docRef, {
        urls: arrayRemove(fileToDelete.downloadURL),
      });
    }

    toast.success(t("FileDeletedSuccessfully"), {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });
  };

  const handleSubmit = async () => {
    setloading(true);
    const uploadPromises = selectedFiles.map(async (file) => {
      if (!file.downloadURL && file.file) {
        try {
          const downloadURL = await uploadImageToService(file.file);
          file.downloadURL = downloadURL;
        } catch (error) {
          console.error("Upload error:", error);
          toast.error(t("FileUploadFailed"), {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          throw error;
        }
      }
    });

    try {
      await Promise.all(uploadPromises);

      const docRef = doc(db, "OurClinc", "images"); // Document path: "OurClinic/images"
      const urls = selectedFiles.map(file => file.downloadURL).filter(url => url !== null);
      await updateDoc(docRef, {
        urls: urls,
      });

      setloading(false);

      toast.success(t("Files Submitted Successfully"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error submitting files:", error);
      setloading(false);
      toast.error(t("File Submission Failed"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  useEffect(() => {
    if (!data && enableReset) {
      setSelectedFiles([]);
    }
  }, [data]);

  useEffect(() => {
    if (dataUpdate?.length === 0 && profileEdit) {
      setSelectedFiles([]);
    }
  }, [dataUpdate]);

  return (
    <div className="all-file-uploaded">
      <div className="file-upload-info file-up">
        <div className="image-upload">
          <img src={uploadImage} alt="upload icon" loading="lazy" />
        </div>
        <div className="info-content">
          <h2 className="title">{t(title)}</h2>
          <p className="text">{t(text)}</p>
        </div>
        <input type="file" multiple accept={accept} onChange={handleFileChange} />
      </div>
      {showText && <p className="text text-2">{t("MaximumImagesSelection")}</p>}

      <div className="all-files-up">
        {selectedFiles.length > 0 && (
          <div>
            <h2 className="title-upload">{t("SelectedFiles")}:</h2>
            <ul className="files-uploaded">
              {selectedFiles.map((file, index) => (
                <li key={index}>
                  {file.type.startsWith("image/") ? (
                    <div className="main-upload-info">
                      <img
                        src={file.preview}
                        alt={file.name}
                        style={{ width: "100px", height: "auto" }}
                      />
                      <button
                        className="button-remove-up"
                        onClick={() => handleDelete(index)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </div>
                  ) : (
                    <div className="main-upload-info">
                      <span>{file.name}</span>
                      <button
                        className="button-remove-up"
                        onClick={() => handleDelete(index)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <button className="btn-main w-100" onClick={handleSubmit} disabled={loading} type={"submit"}>
      {loading ? (
                    <span className="loader"></span>
                  ) : (
                    <>
                     
                 submit
                    </>
                  )}
      </button>
    </div>
  );
};

export default SliderUploader;
